document.documentElement.classList.add('js');

/* ==========================================================================
   Helpers
   ========================================================================== */
function qs(sel, ctx){ return (ctx || document).querySelector(sel); }
function qsa(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

function trapFocus(container){
  var focusable = qsa('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
  if (!focusable.length) return;
  focusable[0].focus();
}

/* ==========================================================================
   Mobile navigation drawer
   ========================================================================== */
(function(){
  var nav = qs('#MobileNav');
  if (!nav) return;
  var openers = qsa('[data-mobile-nav-open]');
  var closers = qsa('[data-mobile-nav-close]', nav);

  function open(){
    nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-open');
    trapFocus(nav);
  }
  function close(){
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-open');
  }

  openers.forEach(function(btn){ btn.addEventListener('click', open); });
  closers.forEach(function(btn){ btn.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && nav.getAttribute('aria-hidden') === 'false') close();
  });
})();

/* ==========================================================================
   Cart drawer — AJAX add / update / remove
   ========================================================================== */
var CartDrawer = (function(){
  var drawer = qs('#CartDrawer');
  if (!drawer) return { open: function(){}, refresh: function(){} };

  var body = qs('[data-cart-drawer-body]', drawer);
  var subtotalEl = qs('[data-cart-subtotal]', drawer);
  var countLabel = qs('[data-cart-count-label]', drawer);
  var headerCountEls = qsa('[data-cart-count]');

  function open(){
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-open');
  }
  function close(){
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-open');
  }

  function renderLine(item){
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
    return '' +
      '<div class="cart-line" data-cart-line data-line-key="' + item.key + '">' +
        '<div class="cart-line__image">' + (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy">' : '') + '</div>' +
        '<div>' +
          '<div class="cart-line__title">' + item.product_title + '</div>' +
          variantLine +
          '<div class="cart-line__qty">' +
            '<button type="button" data-cart-qty-minus aria-label="Menge verringern">' + iconSvg('minus') + '</button>' +
            '<span data-cart-qty-value>' + item.quantity + '</span>' +
            '<button type="button" data-cart-qty-plus aria-label="Menge erhöhen">' + iconSvg('plus') + '</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-cart-remove>Entfernen</button>' +
        '</div>' +
        '<div class="cart-line__price" data-cart-line-price>' + item.final_line_price_formatted + '</div>' +
      '</div>';
  }

  function iconSvg(name){
    if (name === 'minus') return '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
    return '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  }

  function formatMoney(cents){
    var O = '{' + '{', C = '}' + '}';
    var format = window.themeMoneyFormat || ('€' + O + 'amount' + C);
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var noDecimals = Math.round(cents / 100).toString();
    return format
      .replace(O + 'amount_with_comma_separator' + C, withComma)
      .replace(O + 'amount_with_space_separator' + C, withComma)
      .replace(O + 'amount_no_decimals' + C, noDecimals)
      .replace(O + 'amount' + C, amount);
  }

  function render(cart){
    if (!cart.items.length){
      body.innerHTML = '<p class="cart-drawer__empty" data-cart-empty>Dein Warenkorb ist noch leer.</p>';
    } else {
      body.innerHTML = cart.items.map(function(item){
        return renderLine({
          key: item.key,
          product_title: item.product_title,
          variant_title: item.variant_title,
          quantity: item.quantity,
          image: item.image,
          final_line_price_formatted: formatMoney(item.final_line_price)
        });
      }).join('');
    }
    subtotalEl.textContent = formatMoney(cart.total_price);
    if (countLabel) countLabel.textContent = '(' + cart.item_count + ')';
    headerCountEls.forEach(function(el){ el.textContent = cart.item_count; });
  }

  function refresh(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(render);
  }

  function changeLine(key, quantity){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r){ return r.json(); }).then(render);
  }

  qsa('[data-cart-drawer-open]').forEach(function(btn){ btn.addEventListener('click', open); });
  qsa('[data-cart-drawer-close]', drawer).forEach(function(btn){ btn.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  body.addEventListener('click', function(e){
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var qtyEl = qs('[data-cart-qty-value]', line);
    var qty = parseInt(qtyEl.textContent, 10);

    if (e.target.closest('[data-cart-qty-plus]')){
      changeLine(key, qty + 1);
    } else if (e.target.closest('[data-cart-qty-minus]')){
      changeLine(key, Math.max(0, qty - 1));
    } else if (e.target.closest('[data-cart-remove]')){
      changeLine(key, 0);
    }
  });

  return { open: open, close: close, refresh: refresh };
})();

/* ==========================================================================
   Add to cart forms (product page + any quick-add forms)
   ========================================================================== */
qsa('[data-product-form]').forEach(function(form){
  var qtyInput = qs('[data-qty-input]', form);
  var minusBtn = qs('[data-qty-minus]', form);
  var plusBtn = qs('[data-qty-plus]', form);

  if (minusBtn) minusBtn.addEventListener('click', function(){
    var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    qtyInput.value = v;
  });
  if (plusBtn) plusBtn.addEventListener('click', function(){
    var v = (parseInt(qtyInput.value, 10) || 1) + 1;
    qtyInput.value = v;
  });

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var submitBtn = qs('[data-add-to-cart]', form);
    var textEl = qs('[data-add-to-cart-text]', form);
    var originalText = textEl ? textEl.textContent : '';
    if (submitBtn) submitBtn.disabled = true;
    if (textEl) textEl.textContent = 'Wird hinzugefügt …';

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      CartDrawer.refresh();
      CartDrawer.open();
    })
    .catch(function(){
      form.submit(); // graceful fallback: full page submit
    })
    .finally(function(){
      if (submitBtn) submitBtn.disabled = false;
      if (textEl) textEl.textContent = originalText;
    });
  });
});

/* ==========================================================================
   Variant picker (pill buttons -> hidden select -> price/availability)
   ========================================================================== */
qsa('[data-product-form]').forEach(function(form){
  var jsonEl = qs('[data-product-json]', form);
  if (!jsonEl) return;
  var variants;
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  var select = qs('[data-variant-select]', form);
  var priceEl = qs('[data-product-price]');
  var addBtn = qs('[data-add-to-cart]', form);
  var addText = qs('[data-add-to-cart-text]', form);
  var mainImage = qs('#MainProductImage');
  var optionGroups = qsa('[data-option-index]', form);

  function currentSelection(){
    return optionGroups.map(function(group){
      var checked = qs('input[data-option-input]:checked', group);
      return checked ? checked.value : null;
    });
  }

  function findVariant(selection){
    return variants.find(function(v){
      return v.options.every(function(opt, i){ return opt === selection[i]; });
    });
  }

  function applyVariant(variant){
    if (!variant) return;
    select.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (mainImage && variant.featured_image) mainImage.src = variant.featured_image;
    if (addBtn){
      addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
  }

  optionGroups.forEach(function(group){
    group.addEventListener('change', function(){
      var variant = findVariant(currentSelection());
      applyVariant(variant);
    });
  });
});

/* ==========================================================================
   Product image thumbnails
   ========================================================================== */
qsa('[data-product-thumb]').forEach(function(thumb){
  thumb.addEventListener('click', function(){
    var mainImage = qs('#MainProductImage');
    if (!mainImage) return;
    mainImage.src = thumb.getAttribute('data-full-src');
    qsa('[data-product-thumb]').forEach(function(t){ t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });
});

/* ==========================================================================
   Scroll reveal
   ========================================================================== */
(function(){
  var items = qsa('[data-fade]');
  if (!items.length || !('IntersectionObserver' in window)) {
    items.forEach(function(el){ el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  items.forEach(function(el){ io.observe(el); });
})();


/* ==========================================================================
   Duft-Finder — zwei Fragen, ein Ergebnis
   ========================================================================== */
qsa('[data-finder]').forEach(function(sec){
  var state = { less: null, more: null };
  var hint = qs('[data-finder-hint]', sec);
  var results = qsa('[data-finder-result]', sec);

  function update(){
    if (!state.more){ return; }
    if (hint) hint.hidden = true;
    results.forEach(function(r){
      r.hidden = r.getAttribute('data-finder-result') !== String(state.more);
    });
  }

  qsa('[data-finder-group]', sec).forEach(function(group){
    var key = group.getAttribute('data-finder-group');
    group.addEventListener('click', function(e){
      var btn = e.target.closest('button');
      if (!btn) return;
      qsa('button', group).forEach(function(b){ b.setAttribute('aria-pressed', String(b === btn)); });
      state[key] = parseInt(btn.getAttribute('data-value'), 10);
      update();
    });
  });
});

/* ==========================================================================
   Sticky Kaufleiste (Produktseite)
   ========================================================================== */
(function(){
  var bar = qs('[data-sticky-buy]');
  var mainForm = qs('.pdp [data-product-form]');
  if (!bar || !mainForm) return;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
  }, { threshold: 0 });
  io.observe(mainForm);
})();
